import { Box, Text, Secondary } from 'braid-design-system';
import { observer } from 'mobx-react';
import type React from 'react';

import HotjarMask from '../../../common/HotjarMask';

import * as styles from '../PreviousApplications.css';

interface Props {
  title: string;
  content: string;
}

const FieldLine: React.FC<Props> = ({ title, content }) => (
  <Box display="flex">
    <Box className={styles.fieldTitle}>
      <Text>
        <Secondary>{title}</Secondary>
      </Text>
    </Box>
    <Box>
      <Text>
        <HotjarMask>{content}</HotjarMask>
      </Text>
    </Box>
  </Box>
);

export default observer(FieldLine);
